import { BlockStack, InlineStack, Icon, Text } from "@shopify/polaris";
import { ImagesIcon } from "@shopify/polaris-icons";
import AppLayout from "../components/layout";
import PostsLibrary from "../components/PostsLibrary";

export default function Posts() {
  return (
    <AppLayout>
      <BlockStack gap="500">
        <InlineStack align="space-between" gap="300" blockAlign="start">
          <BlockStack>
            <InlineStack gap="200" blockAlign="center" align="start">
              <InlineStack>
                <Icon source={ImagesIcon} />
              </InlineStack>
              <Text variant="headingXl">Posts</Text>
            </InlineStack>
          </BlockStack>
        </InlineStack>
        <PostsLibrary />
      </BlockStack>
    </AppLayout>
  );
}
